export const MIN = 8;
export const MAX = 200;
export const INC = 60;
export const CURRENT = 'current';
export const PAST = 'past';
export const MY_TICKETS = 'my-tickets';
export const VIEW_ORDER = 'view-order';
export const TIMED_ENTRY = 'timed-entry';
export const REGULAR = 'regular';



// WEBPACK FOOTER //
// ./src/constants.js